module.exports = __webpack_public_path__ + "e40934800153aa77e4a084671e95b4af.png";